import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-78b93e09"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center h-30 w-full bg-teal-lighter" }
const _hoisted_2 = { class: "w-full bg-white rounded shadow-lg p-8 m-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "animateMe",
  class: "hover:contrast-125",
  alt: "Logo",
  src: _imports_0,
  width: "125",
  height: "125"
}, null, -1))
const _hoisted_4 = { class: "wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center text-lg font-bold text-green-500 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "slogan",
    class: "w-full bg-white rounded"
  }, " The Community Nurse ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 w-8 h-32 -mt-12 transition-all duration-1000 transform translate-x-12 bg-white opacity-10 rotate-12 group-hover:-translate-x-40 ease" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative" }, "Login", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 w-8 h-32 -mt-12 transition-all duration-1000 transform translate-x-12 bg-white opacity-10 rotate-12 group-hover:-translate-x-40 ease" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative" }, "Sign Up", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "absolute right-0 w-8 h-32 -mt-12 transition-all duration-1000 transform translate-x-12 bg-white opacity-10 rotate-12 group-hover:-translate-x-40 ease" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative" }, "App", -1))

import { IonApp, IonRouterOutlet } from "@ionic/vue";
import { RouterLink, RouterView } from "vue-router";

import { gsap } from "gsap";

import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const tl = gsap.timeline();

onMounted(() => {
tl.to("#animateMe",{
      opacity: 1,
      y: 0,
      rotation: 181,
    },
    {
      duration: 2.5,
      opacity: 1,
      y: 0,
      rotation: 0,
      ease: "power3.inOut",
      delay: 3.5,
    }
  );
     
    });

return (_ctx: any,_cache: any) => {
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", null, [
            _createVNode(_unref(RouterLink), { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_HelloWorld, { msg: "The Community Nurse" }),
              _createElementVNode("nav", null, [
                _createVNode(_unref(RouterLink), {
                  to: "/",
                  class: "text-lg text-left w-18 relative rounded px-5 py-2.5 overflow-hidden group bg-green-400 relative hover:bg-gradient-to-r hover:from-green-500 hover:to-green-400 text-white hover:ring-2 hover:ring-offset-2 hover:ring-green-400 transition-all ease-out duration-300"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createTextVNode("   "),
                _createVNode(_unref(RouterLink), {
                  to: "/signup",
                  class: "text-lg text-right w-24 relative rounded px-5 py-2.5 overflow-hidden group bg-green-400 relative hover:bg-gradient-to-r hover:from-green-500 hover:to-green-400 text-white hover:ring-2 hover:ring-offset-2 hover:ring-green-400 transition-all ease-out duration-300"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createTextVNode("   "),
                _createVNode(_unref(RouterLink), {
                  to: "/app",
                  class: "text-lg text-right w-18 relative rounded px-5 py-2.5 overflow-hidden group bg-green-400 relative hover:bg-gradient-to-r hover:from-green-500 hover:to-green-400 text-white hover:ring-2 hover:ring-offset-2 hover:ring-green-400 transition-all ease-out duration-300"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _hoisted_11
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_unref(RouterView))
    ]),
    _: 1
  }))
}
}

})